import { useState, forwardRef, useImperativeHandle } from 'react';
import { KnowledgeBaseWizard } from '@/components/KnowledgeBaseWizard';
import { useAuthStore } from '@/stores/authStore';
interface KnowledgeBaseStepProps {
  onComplete: () => void;
  setLoading: (loading: boolean) => void;
  onWizardOpenChange?: (isOpen: boolean) => void;
}
export interface KnowledgeBaseStepRef {
  openWizard: () => void;
}
export const KnowledgeBaseStep = forwardRef<KnowledgeBaseStepRef, KnowledgeBaseStepProps>(function KnowledgeBaseStep({
  onComplete,
  setLoading,
  onWizardOpenChange
}, ref) {
  const {
    userId
  } = useAuthStore();
  const [showWizard, setShowWizard] = useState(false);
  
  const handleSetShowWizard = (value: boolean) => {
    setShowWizard(value);
    onWizardOpenChange?.(value);
  };
  
  useImperativeHandle(ref, () => ({
    openWizard: () => handleSetShowWizard(true)
  }));
  if (!userId) return null;
  // If wizard is open, show it inline instead of the default content
  if (showWizard) {
    return (
      <div className="flex-1 flex flex-col">
        <KnowledgeBaseWizard 
          userId={userId} 
          variant="inline" 
          onComplete={() => {
            handleSetShowWizard(false);
            onComplete();
          }} 
          onBack={() => handleSetShowWizard(false)} 
        />
      </div>
    );
  }

  return (
    <div className="flex-1 flex flex-col items-center justify-center text-center space-y-8">
      {/* Title */}
      <h3 className="text-[1.375rem] font-semibold text-white">Mieux on vous connait,<br />plus on est précis.</h3>

      {/* Benefits */}
      <div className="space-y-3 w-full max-w-sm">
        {['Partagez les infos clés de votre business', 'Prenez RDV avec votre Personal Brand Manager', 'Profitez d\'une stratégie éditoriale sur-mesure'].map((benefit, index) => (
          <div key={benefit} className="flex items-center gap-3 p-3 rounded-xl bg-white/[0.03] border border-white/[0.06]">
            <div className="w-6 h-6 rounded-full border border-warning flex items-center justify-center shrink-0">
              <span className="text-warning text-xs font-medium">{index + 1}</span>
            </div>
            <span className="text-sm text-white/80">{benefit}</span>
          </div>
        ))}
      </div>
    </div>
  );
});